export const useStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 3,
    padding: '18px 8px',
  },
});
